import {JBOptInReminderTextContentMRGreenBox} from "./jb-optin-reminder-text-content.mrgreen.box";

export const JbOptinReminderTextContentMrgreenCisBox = JBOptInReminderTextContentMRGreenBox;